import { useMemo } from "react";
import { useIntl } from "react-intl";
import { ChargePriceType } from "entities/stations";

export const useChargePriceTypes = () => {
  const { formatMessage } = useIntl();

  const chargePriceTypes = useMemo(
    () => [
      {
        name: formatMessage({ id: "netPrice" }),
        value: ChargePriceType.NetPrice,
      },
      {
        name: formatMessage({ id: "grossPrice" }),
        value: ChargePriceType.GrossPrice,
      },
      {
        name: formatMessage({ id: "netExcise" }),
        value: ChargePriceType.NetExcise,
      },
    ],
    [formatMessage]
  );

  return chargePriceTypes;
};
